<template>
    <div class="menu">
        <div class="inner-body-block">
            <nuxt-link to="/personal/">
                <fa-icon :icon="faUser"/>
                Личные данные
            </nuxt-link>
            <nuxt-link to="/personal/orders/">
                <fa-icon :icon="faList"/>
                Список заказов
            </nuxt-link>
            <nuxt-link to="/personal/favorites/">
                <fa-icon icon="heart"/>
                Избранное
            </nuxt-link>
            <!-- <nuxt-link to="/personal/reviews/">
                <fa-icon :icon="faStar"/>
                Отзывы
            </nuxt-link>
            <nuxt-link to="/personal/questions/">
                <fa-icon :icon="faCommentAlt"/>
                Вопросы
            </nuxt-link>
            <nuxt-link to="/personal/notifications/">
                <fa-icon :icon="faBell"/>
                Уведомления
            </nuxt-link> -->
            <nuxt-link to="/personal/external-auth/">
                <fa-icon :icon="faKey"/>
                Сторонняя авторизация
            </nuxt-link>
        </div>
    </div>
</template>

<script>
import { faList, faUser, faStar, faCommentAlt, faBell, faKey } from '@fortawesome/free-solid-svg-icons';
export default {
    data: () => ({
        faList, faUser, faStar, faCommentAlt, faBell, faKey
    })
}
</script>

<style lang="scss" scoped>
.menu {
    height: 50px;
    width: 100%;
    display: flex;
    justify-content: center;
    background-color: #e6e6e6;
    margin-bottom: 20px;

    &>.inner-body-block {
        display: flex;
        align-items: stretch;
        &>a {
            display: flex;
            align-items: center;
            font-size: 17px;
            color: #4d4d4d;
            cursor: pointer;
            padding: 0 20px;
            user-select: none;

            transition: background-color .1s ease;

            svg {
                margin-right: 10px;
            }

            &:hover {
                background-color: rgba(0,0,0,0.1);
            }

            &.nuxt-link-exact-active {
                background-color: rgba(0,0,0,0.2);
            }

            @media (max-width: 1300px) {
                padding: 0 15px;
            }
        }
    }
}
</style>